/**
 * Footer Newsletter – Klaviyo Embed Mode
 *
 * Klaviyo decides at runtime whether to inject its embedded form
 * (e.g. it can suppress it for visitors who are already subscribed).
 * We mirror that decision for the whole newsletter block: the theme's
 * heading/bullet points and the reserved layout space only appear once
 * Klaviyo has actually injected content into its target div.
 */

(function () {
  'use strict';

  var REVEAL_TIMEOUT_MS = 6000;

  function reveal(wrapper) {
    wrapper.classList.remove('footer-newsletter--pending');
  }

  function hasInjectedContent(wrapper) {
    // Klaviyo may append content inside the target div, or remove/replace
    // the target div itself with its own element — check the wrapper's
    // subtree broadly instead of relying on a single node reference.
    var target = wrapper.querySelector('[data-klaviyo-embed-target]');
    if (target && target.childElementCount > 0) return true;
    if (!target) return true; // target itself got replaced by Klaviyo
    return false;
  }

  function initWrapper(wrapper) {
    var formArea = wrapper.querySelector('.footer-block__newsletter') || wrapper;

    if (hasInjectedContent(wrapper)) {
      reveal(wrapper);
      return;
    }

    var observer = new MutationObserver(function () {
      if (hasInjectedContent(wrapper)) {
        reveal(wrapper);
        observer.disconnect();
      }
    });

    observer.observe(formArea, { childList: true, subtree: true });

    setTimeout(function () {
      observer.disconnect();
    }, REVEAL_TIMEOUT_MS);
  }

  function boot() {
    document.querySelectorAll('[data-klaviyo-newsletter-wrapper]').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
